import { useState, useEffect } from "react";
import './homepage.css';
import { Footer, Home, Navbar, Konzept, MobileApp, Dates, FAQ, NavbarUser } from '../../containers';

const Homepage = () => {
    let [navbarHeight, setNavbarHeight] = useState(0);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        // Check if the user is logged in or registered by checking sessionStorage
        const token = sessionStorage.getItem("token");
        setIsAuthenticated(!!token);

        const navbar = document.querySelector('.navbarHomepage') || document.querySelector('.navbarUser');
        if (navbar) {
            const height = navbar.offsetHeight;
            setNavbarHeight(height);
        }

        const hash = window.location.hash;

        if (hash) {
            setTimeout(() => {
                const element = document.querySelector(hash);
                if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                }
            }, 200); // small delay ensures render is complete
        }
    }, [navbarHeight]);

    return (
        <div className="App">
            {isAuthenticated ? <NavbarUser /> : <Navbar />}
            <Home></Home>
            <Konzept navbarHeight={navbarHeight}></Konzept>
            <MobileApp navbarHeight={navbarHeight}></MobileApp>
            <Dates navbarHeight={navbarHeight}></Dates>
            <FAQ navbarHeight={navbarHeight}></FAQ>
            <Footer></Footer>
        </div>
    )
}

export default Homepage